import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "CasinoGameSliderWidget" */ './CasinoGameSliderWidget'),
  modules: ['./CasinoGameSliderWidget'],
  loading: () => <div />
});

export default LoadableWidget;
